import { Box, Image } from '@chakra-ui/react';

import LogoGifWithoutLabel from 'assets/gifs/logoWithoutLabel.gif';
import NetchexLoader from 'assets/gifs/netchexLoader.gif';

import { isNetchexLogin } from 'constants/netChexConstants';

type AppLoaderProps = {
  isNetchex?: boolean;
};

export const AppLoader = ({ isNetchex = isNetchexLogin }: AppLoaderProps) => {
  return (
    <Box display="flex" width="100vw" height="100vh" justifyContent="center" alignItems="center">
      <Image w="100px" h="100px" src={isNetchex ? NetchexLoader : LogoGifWithoutLabel} alt="Loader" />
    </Box>
  );
};
